import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=444f44f4"
import script from "./Robot.vue?vue&type=script&lang=js"
export * from "./Robot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports